(function () {
  var CAROUSEL_ID = 'CartUpsellCarousel';
  var DRAWER_ID = 'CartDrawer';
  var SPLIDE_POLL_INTERVAL = 50;
  var SPLIDE_POLL_MAX_ATTEMPTS = 40;

  var currentSplide = null;
  var splideReadyTimer = null;
  var drawerObserver = null;

  function whenSplideReady(callback) {
    if (typeof Splide !== 'undefined') {
      callback();
      return;
    }

    var attempts = 0;
    clearInterval(splideReadyTimer);
    splideReadyTimer = setInterval(function () {
      attempts += 1;
      if (typeof Splide !== 'undefined') {
        clearInterval(splideReadyTimer);
        callback();
      } else if (attempts >= SPLIDE_POLL_MAX_ATTEMPTS) {
        clearInterval(splideReadyTimer);
      }
    }, SPLIDE_POLL_INTERVAL);
  }

  function destroyCurrent() {
    if (!currentSplide) {
      return;
    }

    try {
      currentSplide.destroy();
    } catch (error) {
      currentSplide = null;
    }

    currentSplide = null;
  }

  function mountCarousel() {
    var carousel = document.getElementById(CAROUSEL_ID);

    if (!carousel) {
      destroyCurrent();
      return;
    }

    if (carousel.dataset.splideMounted === 'true') {
      return;
    }

    destroyCurrent();

    var splide = new Splide(carousel, {
      perPage: 1,
      perMove: 1,
      gap: '0.75rem',
      arrows: false,
      pagination: true,
      padding: { right: '2.5rem' },
      mediaQuery: 'min',
      breakpoints: {
        750: {
          padding: { right: '3.5rem' }
        }
      }
    });

    splide.mount();
    currentSplide = splide;
    carousel.dataset.splideMounted = 'true';
  }

  function initCartUpsellCarousel() {
    whenSplideReady(mountCarousel);
  }

  function observeDrawer() {
    if (drawerObserver) {
      return;
    }

    var drawer = document.getElementById(DRAWER_ID);

    if (!drawer) {
      return;
    }

    drawerObserver = new MutationObserver(function () {
      var carousel = document.getElementById(CAROUSEL_ID);
      if (carousel && carousel.dataset.splideMounted !== 'true') {
        initCartUpsellCarousel();
      }
    });

    drawerObserver.observe(drawer, { childList: true, subtree: true });
  }

  function onReady() {
    initCartUpsellCarousel();
    observeDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
